export default __webpack_public_path__ + "static/media/lost.9bf8b97a.jpg";